export default __webpack_public_path__ + "static/media/aws.1baaa078f947505c36dc8ee7595f91da.svg";